<template>
  <section class="pt-3 grey lighten-3">
    <v-container text-xs-center style="max-width: 750px" class="pb-0">
      <v-btn
        v-for="(m, i) in menus.slice(0, expand ? menus.length : 4)"
        :key="i"
        class="my-2"
        :small="$vuetify.breakpoint.xs"
        round
        :dark="activeProgram === m.name ? true : colors[i].dark"
        :color="activeProgram === m.name ? 'secondary' : colors[i].class"
        @click="active(m.name)">{{ `${m.name} (${m.doneCredit}/${m.minCredit})` }}</v-btn>
      <v-btn icon color="grey lighten-1" v-if="expand === false" @click="expand = true">
        <v-icon>more_horiz</v-icon>
      </v-btn>
    </v-container>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { SET_ACTIVE_PROGRAM } from '../store/constants';

const colors = [
  { class: 'blue darken-4', dark: true },
  { class: 'blue darken-3', dark: true },
  { class: 'blue darken-2', dark: true },
  { class: 'blue darken-1', dark: true },
  { class: 'blue lighten-1', dark: false },
  { class: 'blue lighten-2', dark: false },
  { class: 'blue lighten-3', dark: false },
  { class: 'blue lighten-4', dark: false },
  { class: 'blue lighten-5', dark: false },
  { class: 'blue lighten-5', dark: false },
  { class: 'blue lighten-5', dark: false },
  { class: 'blue lighten-5', dark: false },
];

export default {
  name: 'program-menu',
  data() {
    return {
      colors,
      expand: false,
    }
  },
  computed: {
    ...mapGetters(['menus', 'activeProgram'])
  },
  methods: {
    ...mapActions([SET_ACTIVE_PROGRAM]),
    active(name) {
      this[SET_ACTIVE_PROGRAM](name);
      this.$vuetify.goTo('#program-info');
    },
  }
}
</script>
